<template>
  <div class="position-wrap" @scroll="throttleScrollHandle">
    <div v-if="!enableTopOut && unreadCount > 0" class="unread-tip">
      <span @click="topOutHandle">顶部有新消息</span>
    </div>
    <div :style="scrollStyle" class="dynamic">
      <div :class="{ 'dynamic-content': true, atlas: isAtlas }">
        <van-list :finished="finished">
          <!-- 滚动标记 -->
          <ul id="top-empty" style="min-height: 0"></ul>
          <!-- 图文 -->
          <ul v-if="list.length && !isAtlas" class="line">
            <li class="msg-item" v-for="item in list" :key="item.id">
              <div class="time"></div>
              <span class="line-time">{{ moment(item.publishDate).format('HH:mm') }}</span>
              <div class="people">
                <img :src="item.adminHeadImg" alt />
                <div class="admin-name">{{ item.adminName }}</div>
              </div>
              <div class="interview">
                <LongTouch tag="h4" class="title" needCopy @copy="handleCopy(item.text)">
                  {{ item.text }}
                </LongTouch>
                <div class="img-group-wrap">
                  <van-grid v-if="item.imgUrlList.length === 1" class="oneimg" :border="false" :column-num="1" :gutter="3" :center="false">
                    <van-grid-item v-for="value in item.imgUrlList" :key="value">
                      <LongTouch @longTouch="gotouchstart(value)">
                        <van-image
                          width="100%"
                          height="100%"
                          :src="value + '?imageMogr2/auto-orient/thumbnail/600x600>'"
                          @click="viewImage(item.imgUrlList, value)"
                        />
                      </LongTouch>
                    </van-grid-item>
                  </van-grid>
                  <van-grid class="img1" v-if="item.imgUrlList.length === 2" :border="false" :column-num="2" :gutter="3" :center="false">
                    <van-grid-item v-for="value in item.imgUrlList" :key="value">
                      <LongTouch @longTouch="gotouchstart(value)">
                        <van-image
                          width="100%"
                          height="100%"
                          :src="value + '?imageMogr2/auto-orient/thumbnail/600x600>'"
                          @click="viewImage(item.imgUrlList, value)"
                        />
                      </LongTouch>
                    </van-grid-item>
                  </van-grid>
                  <van-grid v-if="item.imgUrlList.length === 3" class="threeimg" :border="false" :column-num="3" :gutter="3" :center="false">
                    <van-grid-item v-for="value in item.imgUrlList" :key="value">
                      <LongTouch @longTouch="gotouchstart(value)">
                        <van-image
                          width="100%"
                          height="100%"
                          :src="value + '?imageMogr2/auto-orient/thumbnail/600x600>'"
                          @click="viewImage(item.imgUrlList, value)"
                        />
                      </LongTouch>
                    </van-grid-item>
                  </van-grid>
                  <!-- -->
                  <van-grid class="img1" v-if="item.imgUrlList.length === 4" :border="false" :column-num="2" :gutter="3" :center="false">
                    <van-grid-item v-for="value in item.imgUrlList" :key="value">
                      <LongTouch @longTouch="gotouchstart(value)">
                        <van-image
                          width="100%"
                          height="100%"
                          :src="value + '?imageMogr2/auto-orient/thumbnail/600x600>'"
                          @click="viewImage(item.imgUrlList, value)"
                        />
                      </LongTouch>
                    </van-grid-item>
                  </van-grid>
                  <van-grid v-if="item.imgUrlList.length > 4" :border="false" :column-num="3" :gutter="3" :center="false">
                    <van-grid-item v-for="value in item.imgUrlList" :key="value">
                      <LongTouch @longTouch="gotouchstart(value)">
                        <van-image
                          width="100%"
                          height="100%"
                          :src="value + '?imageMogr2/auto-orient/thumbnail/600x600>'"
                          @click="viewImage(item.imgUrlList, value)"
                        />
                      </LongTouch>
                    </van-grid-item>
                  </van-grid>
                </div>
                <!-- <div @click="viewImage(item.imgUrl)" v-if="item.imgUrl" class="viewimg">
                <img :src="item.imgUrl" style="object-fit:cover" width="100%" max-height="400px" />
              </div>-->
                <div style="padding: 0 3px;" v-if="item.videoUrlList">
                  <VideoPlayer
                    v-for="value in item.videoUrlList"
                    :key="value"
                    :options="{
                      poster: value + '?vframe/jpg/offset/0',
                      autoplay: false,
                      sources: [
                        {
                          src: value,
                          type: 'video/mp4'
                        }
                      ]
                    }"
                  />
                </div>
              </div>
            </li>
          </ul>
          <!-- 图集 -->
          <ul class="atlas-layout" v-if="isAtlas && list.length">
            <LongTouch tag="li" v-for="item in list" :key="item.id" @longTouch="gotouchstart(item.url)">
              <van-image
                @click="
                  viewImage(
                    list.map((e) => e.url),
                    item.url
                  )
                "
                :radius="4"
                width="100%"
                height="100%"
                fit="cover"
                :src="item.url + '?imageMogr2/auto-orient/thumbnail/600x600>'"
              />
            </LongTouch>
          </ul>
        </van-list>
        <div class="view">
          <!-- 查看历史 -->
          <button v-if="!finished" @click="getlist">查看更多</button>
          <!-- <button v-if="finished">没有更多了</button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { isRmtEnv } from '@/core/index';
import { isInViewPort, throttle } from '@/utils/el';
const portPictureSettingContent = $$.module.data?.room?.portPictureSettingContent;
export default {
  name: 'Dynamic',
  props: {
    scrollStyle: Object
  },
  data() {
    return {
      moment,
      list: [],
      pageNo: 1,
      loading: false, //下拉加载
      finished: true, //下拉加载完毕
      refreshing: false, //下拉刷新
      api: $$.module.interview.$api,
      chartdata: {
        groupId: portPictureSettingContent.picImGroupId,
        nextId: '',
        count: 5
      },
      picFlg: portPictureSettingContent.picFlg,
      showStyle: portPictureSettingContent.showStyle,
      liveState: $$.module.data.room.roomSettingContent.roomInfo.liveState,
      auth: $$.module.data.userinfo.auth,
      value: {},
      enableTopOut: true,
      unreadCount: 0,
      longTimer: null,
      countId: 1,
      throttleScrollHandle: throttle(this.scrollHandle, 100)
    };
  },

  computed: {
    /** 是否为图集 */
    isAtlas() {
      return this.showStyle === '2';
    }
  },

  mounted() {},
  activated() {},

  methods: {
    handleCopy(text) {
      console.log('复制消息', text);
      rmt?.setClipboardText({
        text: text //要设置的文本
      });
      this.$toast('已复制');
    },
    /** 处理长按 */
    gotouchstart(url) {
      if (!isRmtEnv()) return;
      this.$toast.loading({ message: '保存图片中...' });
      this.longPressDownload(url);
    },

    /** 桥接保存图片 */
    longPressDownload(url) {
      rmt.downloadImage({
        images: [{ sourceUrl: url }],
        success: () => {
          this.$message.success('保存成功');
        }
      });
    },

    /** 接受父组件的消息 */
    getMessage(value) {
      if (!value?.length) return;
      let count = 0;
      if (this.enableTopOut) this.topOutHandle();
      const tempMsgs = value.reduce((list, item) => {
        if (!item.payload || !item.payload.text) return list;
        const obj = Object.assign(
          {},
          JSON.parse(item.payload.text),
          { adminHeadImg: item.avatar },
          { adminName: item.nick, createDate: moment(item.time).format('YYYY-MM-DD HH:mm:ss') }
        );
        if (this.isAtlas) {
          if (obj.imgUrlList?.length) {
            list = obj.imgUrlList.map((e) => (count++, { id: this.countId++, url: e })).concat(list);
          }
        } else {
          obj.id = this.countId++;
          list.unshift(obj);
          count++;
        }
        return list;
      }, []);
      this.list = tempMsgs.concat(this.list);
      if (!this.enableTopOut) this.unreadCount += count;
    },

    scrollHandle() {
      this.$nextTick(() => {
        const emptyEl = this.$el.querySelector('#top-empty');
        (this.enableTopOut = isInViewPort(emptyEl)) && (this.unreadCount = 0);
      });
    },
    /** 滚动到顶 */
    topOutHandle() {
      this.$nextTick(() => {
        const emptyEl = this.$el.querySelector('#top-empty');
        if (!isInViewPort(emptyEl)) {
          emptyEl.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          this.enableTopOut = true;
          this.unreadCount = 0;
        }
      });
    },

    /** 桥接查看图片大图 */
    viewImage(list, cur) {
      console.log('click image');
      if (isRmtEnv()) {
        const images = list.map((url) => {
          return {
            sourceUrl: url, //原图路径
            thumbUrl: url //缩略图路径
          };
        });
        rmt.openAlbum({
          currentIndex: images.findIndex((v) => v.sourceUrl === cur), //当前打开第几个图片
          //资源列表
          images
        });
      }
    },

    /** 获取数据 */
    getlist() {
      this.api.chatList({
        data: {
          roomId: $$.module.data.room.roomId,
          pageNo: this.pageNo,
          pageSize: this.isAtlas ? 25 : 8
        },
        success: (data) => {
          if (data.records?.length) {
            this.value = data;
            this.finished = data.totalPage <= this.pageNo;
            this.isAtlas ? this.handleAtlasData(data.records) : this.handleListData(data.records);
          } else {
            this.finished = true;
          }
        }
      });
    },

    /** 处理图文列表数据 */
    handleListData(records) {
      this.list = this.list.concat(
        records.map((e) => {
          e.id = e.id || this.countId++;
          return e;
        })
      );
      this.loading = false;
      this.pageNo++;
      this.scrollHandle();
    },

    /** 处理图集数据 */
    handleAtlasData(records) {
      const list = records.filter((e) => e.imgUrlList?.length);
      if (!list.length) {
        this.pageNo++;
        this.getlist();
        return;
      }

      this.list = list.reduce((pre, cur) => pre.concat(cur.imgUrlList.map((e) => ({ url: e, id: e.id || this.countId++ }))), this.list);

      this.loading = false;
      this.pageNo++;
      this.scrollHandle();
      if (this.list.length < 25) {
        this.getlist();
      }
    },

    onRefresh() {
      this.refreshing = false;
      this.finished = true;
      this.pageNo = 1;
      this.list = [];
      this.getlist(true);
    }
  }
};
</script>
